import AppToolTip from "./AppToolTip";

export default AppToolTip;